import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Card, Form, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import 'react-widgets/styles.css';
import {ROUTE_PATHS as ROUTES}  from 'src/routes';
import { isNotEmptyArray } from 'src/services/validationService';
import { push } from 'connected-react-router';
import { getGlobalDataPeriodsData, getGlobalDataSelectedPeriod, getReportDatesData } from 'src/redux/globalData/globalDataReducer';
import { tryGetReportBudgetAnalyticalAccountingCreditExecution } from 'src/redux/reports/reportsActionCreactor';
import { getReportBudgetAnalyticalAccountingCreditExecutionIsFetching } from 'src/redux/reports/reportsReducer';
import { clearReportBudgetAnalyticalAccountingCreditExecution } from 'src/redux/reports/reportsActions';
import { getListAllServiceAdministrativeByUserData, getListAllServiceAdministrativeByUserIsFetching } from 'src/redux/administrativeService/administrativeServiceReducer';
import { tryListAllServiceAdministrativeByUser } from 'src/redux/administrativeService/administrativeServiceActionCreator';
import { getEmail } from 'src/redux/login/loginReducer';
import { getUserListData } from 'src/redux/user/userReducer';
import { tryGetUserList } from 'src/redux/user/userActionCreator';
import { clearListAllServiceAdministrativeByUser } from 'src/redux/administrativeService/administrativeServiceActions';
import RangeDates from 'src/components/common/RangeDates';
import { shortlistedService } from 'src/utils/utils';
import AppLoading from 'src/components/common/AppLoading';
import { faInfoCircle } from '../../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import MultiselectComponent from '../../common/MultiselectComponent';
import { config } from 'src/env.js';
import OrganismTreeSelect from '../Users/utils/OrganismTreeSelect';
import { useJurisdictions } from '../Users/utils/useJurisdictions';
import { getProfileName } from 'src/redux/login/loginReducer';

const ReportBudgetAnalyticalAccountingCreditExecutionPage = () => {
	const dispatch = useDispatch();
	const methods = useForm();
	const [checkPR, setCheckPR] = useState(false);
	const clickPassiveRemainingHandler = () => {
		setCheckPR(!checkPR);
	};

	const { 
		jurisdictionData, 
		isLoading: jurisdictionsLoading,
		fetchJurisdictions,
		processSelectedOrganisms,
		fetchUserOrganisms,
		userOrganisms
	} = useJurisdictions();
 
	const [selectedOrganisms, setSelectedOrganisms] = useState([]);
	const [filteredJurisdictionData, setFilteredJurisdictionData] = useState([]);
	const profileName = useSelector(state => getProfileName(state));

	//User Id
	const email = useSelector( state => getEmail(state) );
	const listUserData = useSelector(state => getUserListData (state));
	const userId = listUserData?.records?.find(item => item.email == email);
	const [showMsgReportInProcess, setShowMsgReportInProcess] = useState(false);
	const reportDates = useSelector( state => getReportDatesData(state) );

	// Periods
	const periodList = useSelector( state => getGlobalDataPeriodsData(state) )?.data?.sort( (a,b) => a.year<b.year ? 1 : -1 );
	const hasPeriodList = isNotEmptyArray(periodList);
	const globalSelectedPeriod = useSelector( state => getGlobalDataSelectedPeriod(state) );

	//Services Administrative
	const administrativeService = useSelector(state => getListAllServiceAdministrativeByUserData(state))?.sort( (a,b) => a.code>b.code ? 1 : -1 );
	const administrativeServiceIsFetching = useSelector(state => getListAllServiceAdministrativeByUserIsFetching(state));

	// Reports redux
	const reportIsFetching = useSelector(state => getReportBudgetAnalyticalAccountingCreditExecutionIsFetching(state));
	
	const [dateFrom, setDateFrom] = useState(reportDates?.dateFrom);
	const [dateTo, setDateTo] = useState(reportDates?.dateTo);
	const [dateHasErrors, setDateHasErrors] = useState(false);

	useEffect(() => {
		dispatch(tryGetUserList());
		dispatch(clearReportBudgetAnalyticalAccountingCreditExecution());
		dispatch(clearListAllServiceAdministrativeByUser());
		dispatch(tryListAllServiceAdministrativeByUser(userId?.id));		
	}, [globalSelectedPeriod]);

	useEffect(() => {
		fetchJurisdictions();
		if (userId?.id && profileName === 'Consulta por Organismo') {
			fetchUserOrganisms(userId.id);
		}
	}, [fetchJurisdictions, userId?.id, profileName, fetchUserOrganisms]);

	// Multiselect items del selector
	const [options, setOptions] = useState([]);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		let optionsArray = [];
		let i = 0;
		for (i in administrativeService){
			optionsArray.push({label: administrativeService[i]?.code + " - " + administrativeService[i]?.shortName, value:  administrativeService[i]?.id} )
		}
		setOptions(optionsArray);
	}, [administrativeService]);

	useEffect(() => {
		const uniqueService = shortlistedService(options);
		if(uniqueService){
			setSelected(options);
		}
	}, [options]);
	// END Multiselect

	// Filtrar jurisdictionData según los organismos del usuario
	useEffect(() => {
		if (profileName === 'Consulta por Organismo' && userOrganisms.length > 0 && jurisdictionData.length > 0) {
			const userOrganismIds = userOrganisms.map(org => `organism-${org.id}`);
			
			const filtered = jurisdictionData.map(jurisdiction => {
				if (jurisdiction.children) {
					const filteredChildren = jurisdiction.children.filter(child => 
						userOrganismIds.includes(child.value)
					);
					
					if (filteredChildren.length > 0) {
						return {
							...jurisdiction,
							children: filteredChildren
						};
					}
				}
				return null;
			}).filter(item => item !== null);
			
			setFilteredJurisdictionData(filtered);
		} else {
			setFilteredJurisdictionData(jurisdictionData);
		}
	}, [jurisdictionData, userOrganisms, profileName]);

	const getReport = outputFormat => {
		if (globalSelectedPeriod) {
			setShowMsgReportInProcess(false);

			const params = {
				outputFormat,
				exerciseId: globalSelectedPeriod?.id,
				dateFrom,
				dateTo,
				passiveRemaining: checkPR
			};

			// Agregar propiedades según el perfil
			if (profileName === 'Consulta por Organismo') {
				const organismIds = processSelectedOrganisms(selectedOrganisms);
				if (organismIds && organismIds.length > 0) {
					params.organizationIds = organismIds;
				} else {
					console.warn('No se pudieron procesar los organismos seleccionados');
					return;
				}
			} else {
				params.serviceIds = selected?.map(service => service?.value);
			}

			dispatch(tryGetReportBudgetAnalyticalAccountingCreditExecution(params)).then(
				response => {
					if (response?.status == 200) {
						setShowMsgReportInProcess(true);
					}
				}
			);
		}
	};

	const onClickPDF = () => getReport(1);
	const onClickXLS = () => getReport(2);

	const isFormValid = () => {
		// Validaciones comunes
		const hasBasicRequirements = hasPeriodList && !reportIsFetching && dateFrom && dateTo && !dateHasErrors;
		if (!hasBasicRequirements) return false;
		
		// Validaciones según perfil
		if (profileName === 'Consulta por Organismo') {
			// Valida que haya selección de organismos
			return selectedOrganisms && selectedOrganisms.length > 0;
		} else {
			// Valida que haya selección de servicios
			return selected && selected.length > 0;
		}
	};

	return 	(
		<Container fluid>
			<Card className='mb-3'>
				<Card.Header className='d-flex justify-content-between'>
					<h1 className="h6 mt-1 mb-0">Reporte de analítico de contabilidad de presupuesto</h1>
					<a 	className='text-white'
						target="_blank"
						href={config.apis.baseDeConocimientos.URL}
					>
						<FontAwesomeIcon icon={faInfoCircle} className='mr-2' />
						<small>Ver manual de uso</small> 
					</a>
				</Card.Header>  
				<Card.Body>
					<Form>
						<Row>
							<Col className="offset-sm-2 col-sm-8">
								<Form.Group>
									<Form.Label className='text-black-color'>
										Ejercicio
									</Form.Label>			
									<Form.Control 
										type='number' 
										name='globalSelectedPeriod' 
										id='globalSelectedPeriod'
										value={globalSelectedPeriod?.year}
										readOnly
									/>
								</Form.Group>

								{/* Organismos o Servicios según perfil */}
								{profileName === 'Consulta por Organismo' ? (
									<OrganismTreeSelect
										treeData={filteredJurisdictionData}
										value={selectedOrganisms}
										setSelectedOrganisms={setSelectedOrganisms}
										loading={jurisdictionsLoading}
										variant="report"
										placeholder="Seleccione organismos"
									/>
								) : (
									<Form.Group>
										<Form.Label className='text-black-color'>
											Servicio
										</Form.Label>
										<MultiselectComponent
											options={options}
											selected={selected}
											setSelected={setSelected}
											isLoading={administrativeServiceIsFetching}
										/>
									</Form.Group> 
								)}

								{/* Fecha */}
								<FormProvider {...methods}>
									<RangeDates
										{...{dateFrom, setDateFrom, dateTo, setDateTo, setDateHasErrors}}
									/>
								</FormProvider>

								{/* Checkbox Residuos Pasivos */}
								<Form.Group>																										
									<Form.Check 
										type="checkbox"
										id="passiveRemaining"
										label="Residuos Pasivos"
										className="text-black-color"
										onChange={clickPassiveRemainingHandler}
										checked={checkPR}
									/>
								</Form.Group>

								{/* Mensaje de reporte en proceso */}
								{ showMsgReportInProcess &&
									<Alert key={'1'} variant={'primary'} className='mt-4'>
										<b className='text-black-color' >Aviso:</b> El reporte se esta generando en segundo plano y estará disponible en el módulo de 
										<a  className='font-italic text-info cursor-pointer' 
											onClick={() => dispatch(push(ROUTES.REPORT_BUDGET_STATUS_CREDIT_EXECUTION_GENERATED))}>
											&nbsp;reportes generados.
										</a>
									</Alert>
								}

								<Form.Group className='d-flex justify-content-between mt-4'>
									<Button size='lg' onClick={onClickPDF} disabled={!isFormValid}>
										<FontAwesomeIcon icon={faFilePdf} className='mr-2' />
										Generar PDF
									</Button>
									{ reportIsFetching &&
										<Spinner animation='border' />
									}
									<AppLoading isLoading={reportIsFetching} />
									<Button size='lg' onClick={onClickXLS} disabled={!isFormValid}>
										<FontAwesomeIcon icon={faFileExcel} className='mr-2' />
										Generar XLS
									</Button>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default ReportBudgetAnalyticalAccountingCreditExecutionPage;